import { useQuery } from "react-query";
import { getPendingRequestsCountForProject } from "../api/selfonboardingHttpClient";

export const usePendingRequestsCountForProject = (projectId: string | undefined) => {
  const { data: count, isLoading, error } = useQuery(
    ["pendingRequestsCountForProject", projectId],
    () => getPendingRequestsCountForProject(projectId!),
    {
      enabled: !!projectId,
      staleTime: 60000, // 1 minute
      cacheTime: 300000, // 5 minutes
      retry: 1,
      onError: (err) => {
        console.error("Failed to fetch pending requests count for project:", err);
      },
    }
  );

  return {
    count: count ?? 0,
    isLoading,
    error,
  };
};
